import posthog from "posthog-js";

// Product-funnel event tracking. No-ops outside production browser builds.
export function track(event, properties = {}) {
    if (!import.meta.env.PROD || import.meta.env.SSR) {
        return;
    }
    try {
        posthog.capture(event, properties);
    } catch (e) {
        // Analytics must never break the product.
    }
}

export function useAnalytics() {
    return {track};
}
